import { render, staticRenderFns } from "./waveWizard.vue?vue&type=template&id=70a996dc&scoped=true"
import script from "./waveWizard.vue?vue&type=script&lang=js"
export * from "./waveWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a996dc",
  null
  
)

export default component.exports